import React from 'react';

import { QueryId, QueryParamUrlObject } from '@candu-ai/analytics/types';

import { TimeseriesGraph } from './TimeseriesGraph';

interface Props {
  queryParams: QueryParamUrlObject;
  syncId?: string;
  tooltipText?: string;
}

export const ViewsTimeseriesGraph = ({ queryParams, syncId, tooltipText }: Props) => (
  <TimeseriesGraph
    title="Views"
    legend="views"
    withTotalPrefix
    tooltipText={tooltipText}
    queryId={QueryId.ViewsTimeseries}
    queryParams={queryParams}
    syncId={syncId}
  />
);

export const UniqueViewsTimeseriesGraph = ({ queryParams, syncId, tooltipText }: Props) => (
  <TimeseriesGraph
    title="Unique Views"
    legend="unique views"
    withTotalPrefix
    tooltipText={tooltipText}
    queryId={QueryId.UniqueViewsTimeseries}
    aggregateQueryId={QueryId.UniqueViewsMetric}
    queryParams={queryParams}
    syncId={syncId}
  />
);

export const InteractionsTimeseriesGraph = ({ queryParams, syncId, tooltipText }: Props) => (
  <TimeseriesGraph
    title="Interactions"
    legend="interactions"
    withTotalPrefix
    tooltipText={tooltipText}
    queryId={QueryId.InteractionsTimeseries}
    queryParams={queryParams}
    syncId={syncId}
  />
);

export const ConversionTimeseriesGraph = ({ queryParams, syncId, tooltipText }: Props) => (
  <TimeseriesGraph
    title="Conversion rate"
    legend="conversion rate"
    unit="%"
    tooltipText={tooltipText}
    queryId={QueryId.ConversionRateTimeseries}
    aggregateQueryId={QueryId.ConversionRateMetric}
    queryParams={queryParams}
    syncId={syncId}
  />
);

export const ChecklistCompletedTimeseriesGraph = ({ queryParams, syncId, tooltipText }: Props) => (
  <TimeseriesGraph
    title="Checklist Completed"
    legend="checklists completed"
    tooltipText={tooltipText}
    queryId={QueryId.ChecklistsCompletedTimeseries}
    queryParams={queryParams}
    syncId={syncId}
  />
);

export const FormsSubmittedTimeseriesGraph = ({ queryParams, syncId, tooltipText }: Props) => (
  <TimeseriesGraph
    title="Forms Submitted"
    legend="forms"
    tooltipText={tooltipText}
    queryId={QueryId.FormsSubmittedTimeseries}
    queryParams={queryParams}
    syncId={syncId}
  />
);
